
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyConicalXShape as ObiBuoyConicalXShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-conical-x-shape.js';
 
 
 

 
 export const ObiBuoyConicalXShape = createComponent({
   react: React,
   tagName: 'obi-buoy-conical-x-shape',
   elementClass: ObiBuoyConicalXShapeElement,
   events: {
     
   }
  });
 
 